import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import {landingRouting} from './app.routing';
import {CoreModule} from './shared/modules/core/core.module';
import { SharedModule } from './shared/modules/shared/shared.module';
@NgModule({
  declarations: [
    AppComponent,
    landingRouting.components,
    // WalletResponseComponent

  ],
  imports: [
    BrowserModule,
    landingRouting.routes,
    SharedModule,
    CoreModule,
  ],
  providers: [landingRouting.providers],
  bootstrap: [AppComponent]
})
export class AppModule { }
